import { useState } from "react";
import { Play, Youtube } from "lucide-react";

// Extend this list as videos are published. `group` maps a video to a destination
// (or a theme); the page renders one section per group automatically.
const VIDEOS = [
  { id: "737qAVeOfFk", group: "Featured", title: "Your Trusted Partner in Residency & Citizenship", desc: "How we begin every family's journey with understanding, structure and transparency." },
  { id: "cla_oeSSgVI", group: "Featured", title: "The World Has Changed", desc: "Why global mobility and a second base matter more than ever for families." },
  { id: "SXO6xy_Bmcs", group: "Featured", title: "Making Your Passport Strong", desc: "How a second residency or citizenship strengthens your family's global access." },
  { id: "iIamfsiex-U", group: "Featured", title: "Residency & Citizenship by Investment", desc: "An overview of the pathways to residency and second citizenship." },

  { id: "2teKs6TqWaA", group: "Dubai & UAE", title: "Dubai Residency with Zero Investment", desc: "Qualifying for a UAE Golden Visa through income and financial profile." },
  { id: "8R4mia1aUWY", group: "Dubai & UAE", title: "Dubai Golden Visa with Investment", desc: "The investment routes to a 10-year UAE Golden Visa." },
  { id: "Q3VN4IwSCYc", group: "Dubai & UAE", title: "Dubai Golden Visa without Property", desc: "Golden Visa options that don't require a property purchase." },
  { id: "0vf2YQh1aWk", group: "Dubai & UAE", title: "Dubai Company Set-Up & Compliance", desc: "Establishing a UAE company with banking, audit and compliance support." },
  { id: "ugxjxrbSmsk", group: "Dubai & UAE", title: "Your Golden Visa, Life-Changing", desc: "More than a card — the lifestyle a Dubai Golden Visa unlocks." },

  { id: "1FQ6-D_1p8g", group: "Guides & Podcast", title: "Our 4-Step Process", desc: "How we take you from exploration to a clear, structured plan." },
  { id: "FHNWNQeZr8M", group: "Guides & Podcast", title: "Golden Visa Secrets Revealed", desc: "The smarter way to global access through Golden Visa programmes." },
  { id: "AIIyrpDuqDc", group: "Guides & Podcast", title: "Podcast: Residency Decisions for Your Children", desc: "The right time and the right path when planning around children's futures." },
];

const thumb = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

export default function VideosPage() {
  const [active, setActive] = useState(VIDEOS[0]);

  const groups = [...new Set(VIDEOS.map((v) => v.group))];

  return (
    <div className="mx-auto max-w-lg px-4 pb-8 pt-4" data-testid="videos-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="flex items-center gap-2 text-2xl font-semibold text-white" style={{ fontFamily: "'Syne', sans-serif" }}>
            <Youtube size={22} className="text-red-500" /> Videos
          </h1>
          <p className="mt-1 text-sm text-slate-300">Insights and stories from across the world of global mobility.</p>
        </div>
      </div>

      {/* featured player */}
      {active && (
        <div className="mt-4 overflow-hidden rounded-2xl border border-white/[0.08] bg-black" data-testid="video-player">
          <div className="relative w-full" style={{ aspectRatio: "16 / 9" }}>
            <iframe
              key={active.id}
              className="absolute inset-0 h-full w-full"
              src={`https://www.youtube.com/embed/${active.id}?rel=0`}
              title={active.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
          <div className="p-4">
            <h2 className="text-base font-semibold leading-snug text-white">{active.title}</h2>
            {active.desc && <p className="mt-1 text-[13px] leading-snug text-slate-300">{active.desc}</p>}
          </div>
        </div>
      )}

      {/* grouped grid */}
      {groups.map((g) => (
        <section key={g} className="mt-6">
          <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.2em] text-amber-400/90">{g}</p>
          <div className="grid grid-cols-2 gap-3">
            {VIDEOS.filter((v) => v.group === g).map((v) => (
              <button
                key={v.id}
                data-testid={`video-card-${v.id}`}
                onClick={() => setActive(v)}
                className="group overflow-hidden rounded-2xl border border-white/[0.07] bg-white/[0.03] text-left transition-colors hover:border-amber-300/30"
              >
                <div className="relative aspect-video w-full overflow-hidden">
                  <img src={thumb(v.id)} alt={v.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 grid place-items-center bg-black/25 opacity-0 transition-opacity group-hover:opacity-100">
                    <span className="grid h-10 w-10 place-items-center rounded-full bg-amber-300 text-[#07090E]">
                      <Play size={16} className="ml-0.5" fill="currentColor" />
                    </span>
                  </div>
                  {active?.id === v.id && (
                    <span className="absolute left-2 top-2 rounded-full bg-red-500 px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wider text-white">
                      Playing
                    </span>
                  )}
                </div>
                <p className="p-3 text-[13px] font-semibold leading-snug text-white">{v.title}</p>
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
